import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { TemplatesService } from './templates.service';
@Injectable({
  providedIn: 'root',
})
export class TemplatesResolver {
  public hasPermissions: boolean = false;

  constructor(private templatesService: TemplatesService) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.templatesService.getTemplates();
  }
}
